import { render, staticRenderFns } from "./BedroomsSelect.vue?vue&type=template&id=ba793518&lang=pug&"
import script from "./BedroomsSelect.vue?vue&type=script&lang=js&"
export * from "./BedroomsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports